import { useState } from 'react';
import { DataGridContext } from '@/contexts/DataGrid';
import { ReactElement } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
export interface QueryParams {
  page: number;
  totalCount: number;
  size: number;
  search: string;
}

interface DataGridProviderProps {
  children?: ReactElement;
  query: (params: QueryParams) => any;
}

interface ResponseType {
  content: [any];
  totalPages: number;
  pageSize: number;
  pageNumber: number;
}

export function DataGridProvider({ children, query }: DataGridProviderProps) {

  const [selecteds, setSelecteds] = useState<string[]>([]);
  const [page, setPage] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(90);
  const [size, setSize] = useState<number>(20);
  const [search, setSearch] = useState<any>({});

  const queryResult: UseQueryResult<ResponseType> = query({
    page,
    totalCount,
    size,
    ...search,
  });

  const context = {
    queryResult,
    selecteds,
    page,
    totalCount,
    perPage: size,
    search,
    setSelecteds,
    setPage,
    setTotalCount,
    setPerPage: setSize,
    setSearch,
  };

  return (
    <DataGridContext.Provider value={context}>
      {children}
    </DataGridContext.Provider>
  );
}
